import React from "react";
import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Drawer, useMediaQuery } from "@mui/material";

import { BrowserView, MobileView } from "react-device-detect";

// project imports
// import LogoSection from '../LogoSection';
import MenuList from "../MenuList/index";
import { drawerWidth } from "../../store/constant";
import pasteLogo from "../../assets/images/COPYPASTE2.svg";
import { Link } from "react-router-dom";
// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));

  const drawer = (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Box sx={{ display: "flex", p: 2, mx: "auto" }}>
          {/* <LogoSection /> */}
          <Link to="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              width={150} // The original width
              height={35} // The original height
              src={pasteLogo}
              alt="Copy Paste"
              title="Copy Paste - Just Paste It"
              loading="lazy"
              style={{ cursor: "pointer" }}
            />
          </Link>
        </Box>
      </Box>
      <BrowserView>
        <MenuList />
      </BrowserView>
      <MobileView>
        <Box sx={{ px: 2 }}>
          <MenuList />
        </Box>
      </MobileView>
    </>
  );

  const container =
    window !== undefined ? () => window.document.body : undefined;

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : "auto" }}
      aria-label="mailbox folders"
    >
      <Drawer
        container={container}
        variant={matchUpMd ? "persistent" : "temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: "none",
            overflowY: "auto",
            overflowX: "hidden",
            maxHeight: "calc(100vh - 128px)", // Ensure it doesn't exceed viewport
            [theme.breakpoints.up("md")]: {
              top: "128px", // 88px original + 40px banner height
            },
          },
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default Sidebar;
